/**
 * The Rappi APP WebView injects some auxiliary functions on the window object.
 */

/**
 * Closes the WebView, redirecting the user to the Rappi APP home.
 */
export const goBackToApp = () => {
  if (window.app?.endCall) window.app.endCall();
  if (window.appInterface?.endCall) window.appInterface.endCall();
  if (window.webkit?.messageHandlers?.endCall?.postMessage) window.webkit.messageHandlers.endCall.postMessage('');
};

/**
 * Opens the given URL on the native browser.
 */
export const openURL = (url: string) => {
  if (window.app?.openURL) window.app.openURL(url);
  else if (window.appInterface?.openURL) window.appInterface.openURL(url);
  else if (window.webkit?.messageHandlers?.openURL?.postMessage) window.webkit.messageHandlers.openURL.postMessage(url);
  else window.open(url);
};
